export const PointStructure = [
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: '02',
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'point',
        claimed: false,
        earned_at: null,
        expires_at: null,
    },
    {
        id: null,
        type: 'milestone',
        claimed: false,
        earned_at: null,
        expires_at: null,
    }
]